<span class="supplier-statut-badge" *ngIf="supplierStatut" [ngClass]="badgeNgClass">
    <paflabel [lblCod]="statutLibCod"></paflabel>
    <!-- <PRE *ngIf="sharedDataSvc.debug">Id/Cod:{{statutId}}/{{statutCod}}</PRE> -->
</span>